import PropTypes from 'prop-types';

const propTypes = {
  legacy: PropTypes.bool,
  visualizerType: PropTypes.string,
  playerId: PropTypes.string,
  mediaOriginId: PropTypes.string,
  customProps: PropTypes.object,
  playlist: PropTypes.arrayOf( PropTypes.object),
};

export default propTypes;



// WEBPACK FOOTER //
// ./src/base-player/prop-types.js